/**
 * Get clientId from google analytics API
 * 
 * @returns {string} clientId
 */
function getGoogleAnalyticsClientId() {
    if (typeof window !== 'undefined' && typeof window.ga !== 'function') {
        throw new Error('[GoogleAnalytics] global ga function is not defined');
    }

    try {
        const [ defaultTracker ] = window.ga.getAll();
    
        return defaultTracker.get('clientId');
    } catch {
        return null;
    }
}

export default getGoogleAnalyticsClientId;
